/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../globalTraduction";
import { useStoreCurrencies } from "../../store/dataCurrencies";
import { UserPreferences } from "../../store/UserPreferences";
import "../../styles/components/choiceLanguageDeviseModal.css";
import "../../styles/components/signalementModal.css";

export default function ChoiceLanguageDeviseModal() {
  const {
    handleChangeDevise,
    handleChangeShowDevise,
    userLanguage,
    showDevise,
    devise,
    sign,
  } = UserPreferences();
  const {
    currencies,
    currentCurrencyId,
    handleUpdateCurrentCurrencyId,
    handleUpdateSign,
  } = useStoreCurrencies();
  const { t } = useTranslation();
  const iLanguage = i18n.language;
  const [deviseSelected, setDeviseSelected] = useState(devise);
  const [showDeviseSelected, setShowDeviseSelected] = useState(showDevise);
  const [signSelected, setSignSelected] = useState(sign);
  const [selectedCurrency, setSelectedCurrency] = useState(currentCurrencyId);
  const [currentMenu, setCurrentMenu] = useState(1);
  const [canConfirm, setCanConfirm] = useState(false);
  const [canConfirmChangeLanguage, setCanConfirmChangeLanguage] =
    useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(iLanguage);
  useEffect(() => {
    if (selectedCurrency !== currentCurrencyId) {
      setCanConfirm(true);
    } else {
      setCanConfirm(false);
    }
  }, [selectedCurrency]);
  const handleConfirm = () => {
    handleUpdateCurrentCurrencyId(selectedCurrency);
    handleChangeDevise(deviseSelected);
    if (signSelected === "€") {
      handleChangeShowDevise("€");
    } else {
      handleChangeShowDevise(showDeviseSelected);
    }
    handleUpdateSign(signSelected);
    window.location.reload();
  };
  const handleConfirmChangeLanguage = () => {
    localStorage.setItem("tc-language-active", selectedLanguage);
    setCanConfirmChangeLanguage(false);
    UserPreferences.getState().handleChangeLanguage(selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
    window.location.reload();
  };
  useEffect(() => {
    if (selectedLanguage != iLanguage) {
      setCanConfirmChangeLanguage(true);
    } else {
      setCanConfirmChangeLanguage(false);
    }
  }, [selectedLanguage]);
  return (
    <div className="signalement-modal choice-user | flcolm">
      <div className="choose-menu | flrow liner maxwidth">
        <button
          onClick={() => setCurrentMenu(1)}
          className={`btn btn-new ${currentMenu == 1 ? "selected" : ""}`}
        >
          <span>{t("modals.choiceLanguageDevise.selectLangueLabel")}</span>
        </button>
        <button
          onClick={() => setCurrentMenu(2)}
          className={`btn btn-new ${currentMenu == 2 ? "selected" : ""}`}
        >
          <span>{t("modals.choiceLanguageDevise.selectDeviseLabel")}</span>
        </button>
      </div>

      <div
        className={`contents side-scroll ${
          currentMenu == 2 ? "show-devise" : ""
        } | flrow`}
        style={currentMenu == 1 ? { height: 195 } : {}}
      >
        <div className="selectors | flcolm">
          <button
            onClick={() => {
              setSelectedLanguage("fr");
            }}
            className="select-btn btn-new | btn btw rlve"
          >
            <span>{t("modals.choiceLanguageDevise.francaisName")} </span>
            <div className="selector-circle rlve">
              {selectedLanguage == "fr" && (
                <span className="center-absolute"></span>
              )}
            </div>
          </button>
          <button
            onClick={() => {
              setSelectedLanguage("en");
            }}
            className="select-btn btn-new | btn btw rlve"
          >
            <span>{t("modals.choiceLanguageDevise.anglaisName")}</span>
            <div className="selector-circle rlve">
              {selectedLanguage == "en" && (
                <span className="center-absolute"></span>
              )}
            </div>
          </button>
          <button
            disabled={!canConfirmChangeLanguage}
            className="btn confirm-btn"
            onClick={handleConfirmChangeLanguage}
          >
            <span>{t("modals.choiceLanguageDevise.confirmTxt")}</span>
          </button>
        </div>
        <div className="selectors | flcolm">
          {currencies.currencies.map((currency) => (
            <button
              key={currency.id}
              onClick={() => {
                setSelectedCurrency(currency.id);
                setShowDeviseSelected(currency.code);
                setDeviseSelected(currency.name);
                setSignSelected(currency.sign);
              }}
              className="select-btn | btn btw rlve"
            >
              <span>{`(${currency.code}) ${currency.name}`}</span>
              <div className="selector-circle rlve">
                {selectedCurrency === currency.id && (
                  <span className="center-absolute"></span>
                )}
              </div>
            </button>
          ))}
          <button
            disabled={!canConfirm}
            className="btn confirm-btn"
            onClick={handleConfirm}
          >
            <span>{t("modals.choiceLanguageDevise.confirmTxt")}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
